const readLookupText = (value) => {
  if (typeof value === 'string') return value.trim()

  if (value && typeof value === 'object') {
    const localizedValue =
      value.en ?? value.fr ?? value.label ?? value.name ?? value.title ?? value.value ?? null

    if (typeof localizedValue === 'string') {
      return localizedValue.trim()
    }
  }

  return ''
}

const extractArray = (value) => {
  if (Array.isArray(value)) return value
  if (!value || typeof value !== 'object') return []

  const candidates = [
    value.data,
    value.items,
    value.results,
    value.categories,
    value.goal_categories,
    value.goalCategories,
    value.skill_groups,
    value.skillGroups,
    value.groups,
    value.sectors,
    value.skills,
  ]

  for (const candidate of candidates) {
    const list = extractArray(candidate)
    if (list.length) return list
  }

  return []
}

export const toLookupOption = (item) => {
  if (typeof item === 'string') {
    const value = item.trim()
    if (!value) return null

    return { id: value, label: value, value }
  }

  if (!item || typeof item !== 'object') return null

  const label =
    readLookupText(item.label) ||
    readLookupText(item.name) ||
    readLookupText(item.title) ||
    readLookupText(item.preferred_label) ||
    readLookupText(item.preferredLabel) ||
    readLookupText(item.skill) ||
    readLookupText(item.goal_category) ||
    readLookupText(item.category) ||
    readLookupText(item.objective) ||
    readLookupText(item.sector) ||
    readLookupText(item.industry)

  if (!label) return null

  return {
    id: item.id ?? item.uuid ?? item.code ?? item.slug ?? label,
    label,
    value: label,
  }
}

export const normalizeLookupOptions = (value) => {
  const seen = new Set()

  return extractArray(value)
    .map((item) => toLookupOption(item))
    .filter(Boolean)
    .filter((item) => {
      const key = item.value.toLowerCase()
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
}

export const mergeLookupOptions = (...lists) => {
  const seen = new Set()

  return lists
    .flat()
    .filter((item) => {
      const key = item.value.toLowerCase()
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
}

export const normalizeStringList = (values, maxItems = null) => {
  const seen = new Set()
  const normalized = []

  for (const raw of values ?? []) {
    const value = String(raw ?? '').trim()
    if (!value) continue

    const key = value.toLowerCase()
    if (seen.has(key)) continue

    seen.add(key)
    normalized.push(value)

    if (maxItems != null && normalized.length >= maxItems) break
  }

  return normalized
}

export const addStringSelection = (current, value, maxItems = null) => {
  const trimmed = String(value ?? '').trim()
  if (!trimmed) return normalizeStringList(current, maxItems)

  return normalizeStringList([...(current ?? []), trimmed], maxItems)
}
